import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  ActionDeleteIcon,
  CheckIcon,
  CloseIcon,
  ErorrIcon,
} from "../../../../assets/icons";
import PortalForModal from "../portals/PortalForModal";

/**
 * The common toaster component
 */
export default function Toaster(props: any) {
  /**
   * props.type-
   * * changes on success, delete & fail type
   *
   * * **success**
   *        * indicates successful action
   * * **delete**
   *        * indicates successful deletion
   * * **fail**
   *        * indicates failed/unsuccessful action due to process/api failure
   *
   * props.highlightedText-
   * * **shows meeting title in highlighted text if exist
   * props.toasterBodyMessage-
   * * **shows body message of toaster
   *
   */

  const [toasterOpen, setToasterOpen] = useState(true); //toaster open or close

  /**
   * toaster close button style
   */
  const iconStyle = {
    height: "1.4rem",
    width: "1.3rem",
  };

  /**
   * switch case for adding success, delete and fail icons as per props.type
   */

  function iconClassSwitch(name: any) {
    switch (name) {
      case "success":
        return (
          <span className="cnv-action-add">
            {" "}
            <CheckIcon style={iconStyle} />
          </span>
        );
      case "delete":
        return (
          <span className="cnv-action-delete">
            {" "}
            <ActionDeleteIcon style={iconStyle} />
          </span>
        );
      case "fail":
        return (
          <span className="cnv-action-delete">
            {" "}
            <ErorrIcon style={iconStyle} />{" "}
          </span>
        );
    }
  }

  /**
   * close the toaster
   */
  function toasterClose() {
    setToasterOpen(false); //here
    props.closeToaster(toasterOpen);
  }
  /**
   * type of the toaster and close toaster for 4 sec
   */

  useEffect(() => {
    setTimeout(() => {
      toasterClose();
    }, props.closeToasterTimeout ?? 4000);
  }, [toasterOpen]);

  return (
    <div>
      <PortalForModal>
        <div
          id={props.id ? `${props.id} cnv-toast` : "cnv-toast"}
          className={classNames(props.className, {
            "cnv-toast-add": props.type === "success",
            "cnv-toast-delete": props.type !== "success",
          })}
          style={{
            ...props.customStyle,
            right: "4px",
            display: "block",
            zIndex: 1001,
          }}
        >
          <span className="cnv-toast-close">
            <CloseIcon style={iconStyle} onClick={toasterClose} />
          </span>

          {props.showIconType && iconClassSwitch(props.type)}
          {props.heading ? (
            <div className="cnv-toast-heading">{props.heading}</div>
          ) : (
            <></>
          )}
          <div className="cnv-toast-body">
            {props.toasterBodyMessage}{" "}
            {props.highlightedText ? <span>{props.highlightedText}</span> : ""}{" "}
          </div>
        </div>
      </PortalForModal>
    </div>
  );
}

Toaster.defaultProps = {
  className: null,
  showIconType: true,
};
